<template>
  <div class="small">
    <line-chart
      v-if="this.datacollection"
      :chart-data="datacollection"
      :options="chartoptions"
      :height="250"
    ></line-chart>
  </div>
</template>

<script>
import LineChart from "./PriceChart/LineChart";

export default {
  props: ['chartvalues', 'colors'],
  components: {
    LineChart
  },
  data () {
    return {
      datacollection: null,
      datavalue: {
        labels: [],
        values: []
      },
      chartoptions: {
        legend: {
          display: false
        },
        scales: {
          yAxes: [{
            display: true,
            ticks: {
              suggestedMin: 0,
              suggestedMax: 2000,
              beginAtZero: false,
              autoSkip: false
            },

            scaleLabel: {
              display: true,
              labelString: 'Prezzo al mq'
            }
          }]
        }
      }
    }
  },

  mounted () {
    this.fillData();
  },

  methods: {
    fillData () {
      this.chartoptions.scales.yAxes[0].ticks.suggestedMin = this.suggestedMin;
      this.chartoptions.scales.yAxes[0].ticks.suggestedMax = this.suggestedMax;

      this.datacollection = {
        labels: this.chartvalues.labels,
        datasets: [
          {
            label: 'Prezzo € al mq',
            borderColor: this.colors ? this.colors.primary : '#000',
            data: this.chartvalues.values
          }
        ]
      }
    },
  },

  computed: {
    suggestedMin () {
      return Math.floor((Math.min(...this.chartvalues.values) * 0.98) / 50) * 50;
    },
    suggestedMax () {
      return Math.ceil((Math.max(...this.chartvalues.values) * 1.02) / 50) * 50;
    }
  }
}
</script>

<style lang="css" scoped>
.small {
  max-width: 600px;
  margin: 10px auto;
}</style>
